const base = {
    // host: 'https://pbl2.zdwkj.com',
    host: 'http://192.168.3.125',
    project: '/api/ycsj_pbl_program',
    scratch: '/scratch3.0',
    phone: '/phone'
}
export default base